import { createAction } from '@reduxjs/toolkit'
import { TakeableObjectManifestJson } from '../API/InteractableObjectJson'
import Config from '../Containers/Config'
import InventoryContainer from '../Containers/InventoryContainer/InventoryContainer'
import AudioController from '../Controllers/AudioController'
import dispatch from '../Utility/dispatchAction'
import Image from './Image'
import InfoLayer from './InfoLayer'
import InteractableObject from './InteractableObject'
import InteractiveLayer from './InteractiveLayer/InteractiveLayer'

export const takeableObjectActionType = 'TakeableObject.interact'
export const createTakeableObjectAction = createAction(
    takeableObjectActionType,
    (takeableObject: TakeableObject, action?: string) => ({
        payload: {
            takeableObject,
            action,
        },
    })
)

const getImagePath = (gameSceneId: string, overlayImage: string) =>
    `${Config.GAME_SCENE_PATH}${gameSceneId}/${overlayImage}.png`

export const createTakeableObjectListener = (id: string, callback?: () => void, once = true): Promise<TakeableObject> =>
    new Promise((resolve) => {
        const handler: EventListener = (event) => {
            // @ts-ignore -- WHY: CustomEvent
            const takeableObject = event.detail.takeableObject as TakeableObject

            if (takeableObject.id === id) {
                once && removeEventListener(takeableObjectActionType, handler)
                callback && callback()
                resolve(takeableObject)
            }
        }

        addEventListener(takeableObjectActionType, handler)
    })

export default class TakeableObject extends InteractableObject {
    gameSceneElement: HTMLDivElement
    inventoryItemId: string
    // image representation in game scene
    image: Image

    constructor(
        manifest: TakeableObjectManifestJson,
        interactiveLayer: InteractiveLayer,
        infoLayer: InfoLayer,
        gameSceneElement: HTMLDivElement,
        gameSceneId: string
    ) {
        super(manifest, interactiveLayer, infoLayer)
        this.inventoryItemId = manifest.inventoryItemID
        this.gameSceneElement = gameSceneElement
        this.image = new Image(getImagePath(gameSceneId, manifest.overlayImage))

        // TODO: use GameSceneImage instead
        this.image.element.classList.add('overlay-image')
        this.gameSceneElement.prepend(this.image.element)
    }

    load = () => this.image.load()

    commitInteraction = () => {
        InventoryContainer.addItems([this.inventoryItemId])
        dispatch(createTakeableObjectAction(this, this.interactData?.action))

        this.destroy()
    }

    destroy = () => {
        this.interactiveElement.remove()
        this.hotSpotElement.remove()
        this.inspectData?.audioId && AudioController.remove(this.inspectData.audioId)
        this.interactData?.audioId && AudioController.remove(this.interactData.audioId)

        this.gameSceneElement.removeChild(this.image.element)
        this.image.destroy()
    }

    show = () => {
        this.interactiveElement.classList.remove('hidden')
        this.interactiveElement.classList.remove('hidden')
        this.image.show()
    }

    hide = () => {
        this.interactiveElement.classList.add('hidden')
        this.hotSpotElement.classList.add('hidden')
        this.image.hide()
    }
}
